// extracted by mini-css-extract-plugin
module.exports = {"watchLink":"Link_watchLink__a32Il"};